import f from "./ghl-ui.es1505.js";
import i from "./ghl-ui.es1506.js";
import g from "./ghl-ui.es1580.js";
import n from "./ghl-ui.es1466.js";
function C(t, r, o) {
  n(2, arguments);
  var e = i(t), a = f(r), m = g(e, o) - a;
  return e.setUTCDate(e.getUTCDate() - m * 7), e;
}
export {
  C as default
};
